import "bootstrap/dist/css/bootstrap.min.css";
import CustomNavbar from "./Component/CustomNavbar/CustomNavbar";
import Footer from "./Component/Footer/Footer";
import CustomRoutes from "./Component/CustomRoutes/CustomRoutes";
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga";

function App() {
  const location = useLocation();
  const [isHomePage, setIsHomePage] = useState(false);

  useEffect(() => {
    if (location.pathname === "/") {
      setIsHomePage(true);
    } else {
      setIsHomePage(false);
    }
  }, [location]);

  // Track page views with Google Analytics
  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);

  return (
    <>
      <div dir="rtl" className={isHomePage ? "" : "bg-not-home-page"}>
        <CustomNavbar />

        {/*{isHomePage && <MagneticDots />}*/}

        <CustomRoutes />

        <Footer />
      </div>
    </>
  );
}

export default App;
